import React from "react";

import styled from "styled-components";

import "./copy.styles.scss";

interface CopyProps {
  element: any;
  children: any;
  props: any;
}

const StyledCopy = styled.p``;

export const Copy = ({ element = "p", children, ...props }: CopyProps) => (
  <StyledCopy as={element} {...props}>
    {children}
  </StyledCopy>
);
